﻿import { UTL } from "../util/classes";
import { PopupPlusStyleRecord, PopupPlusAuxFunctions } from "./popupPlus_Aux"; // <--- ייבוא הפונקציה הספציפית

export class ConfirmPlus {
    private static IS_INITIALZED: boolean = false;
    private static overlay_element: HTMLDivElement = null;
    private static popup_element: HTMLDivElement = null;
    private static caption_element: HTMLDivElement = null;
    private static text_element: HTMLDivElement = null;
    private static panel_element: HTMLDivElement = null;
    private static ok_button_element: HTMLButtonElement = null;
    private static cancel_button_element: HTMLButtonElement = null;

    public static resolve_function_pointer: Function = null; // ומשתנה זה רק שומר מצביע אליה executor_function כדי להזכיר שזאת לא פונקציה שלנו אלא פונקציה שקיבלנו מאת ה "_pointer" הוספנו את המילה
    public static par_text_str: string = "";
    //public static par_caption_exist: boolean = false;
    public static par_caption_str: string = "";
    public static par_style_rec: PopupPlusStyleRecord = null;

    private static overlay_keydown(event: KeyboardEvent): void {
        if (PopupPlusAuxFunctions.keydown_event_should_preventDefault(event) == true) {
            event.preventDefault(); // לשים את הפקודה הזאת gemini :הערה
            event.stopPropagation(); // לשים את הפקודה הזאת gemini :הערה
        }
        if (event.key === 'Tab') {
            if (event.shiftKey == false) {
                //alert("Tab");
                UTL.MOVE_FOCUS_Forward(ConfirmPlus.cancel_button_element, ConfirmPlus.ok_button_element)
            }
            if (event.shiftKey == true) {
                //alert("Shift+Tab");
                UTL.MOVE_FOCUS_Backwards(ConfirmPlus.cancel_button_element, ConfirmPlus.ok_button_element)
            }
        }

        if (event.key === 'Enter') {
            if (document.activeElement === ConfirmPlus.ok_button_element) {
                ConfirmPlus.perform_ok();
            }
            if (document.activeElement === ConfirmPlus.cancel_button_element) {
                ConfirmPlus.perform_cancel();
            }
        }
        if (event.key === 'Escape') {
            ConfirmPlus.perform_cancel();
        }
    }

    static overlay_mousedown(event: MouseEvent) {
        //---------------------------------------------------------------------------------------------
        //                               ."event.preventDefault();" שים לב. אנחנו מפעילים באירוע הזה את
        // למה? בגלל שאם לא מבצעים זאת אז לחיצה על העכבר במקום כלשהו גורמת לפוקוס לעבור למקום אחר כלשהו
        //---------------------------------------------------------------------------------------------
        event.preventDefault(); // הלך לאיבוד focus ללא השורה הזאת ה
        //ConfirmPlus.ok_button_element.focus();
    }

    private static perform_INITIALZE_INA() {
        const freezed_IS_INITIALZED: boolean = ConfirmPlus.IS_INITIALZED;
        if (freezed_IS_INITIALZED == false) {
            ConfirmPlus.overlay_element = document.createElement("div");;
            ConfirmPlus.popup_element = document.createElement("div");;
            ConfirmPlus.caption_element = document.createElement("div");;
            ConfirmPlus.text_element = document.createElement("div");;
            ConfirmPlus.panel_element = document.createElement("div");;
            ConfirmPlus.ok_button_element = document.createElement("button");;
            ConfirmPlus.cancel_button_element = document.createElement("button");;
            //-----------------------------
            ConfirmPlus.overlay_element.appendChild(ConfirmPlus.popup_element);
            ConfirmPlus.popup_element.appendChild(ConfirmPlus.caption_element);
            ConfirmPlus.popup_element.appendChild(ConfirmPlus.text_element);
            ConfirmPlus.popup_element.appendChild(ConfirmPlus.panel_element);
            ConfirmPlus.panel_element.appendChild(ConfirmPlus.ok_button_element);
            ConfirmPlus.panel_element.appendChild(ConfirmPlus.cancel_button_element);
            //-----------------------------
            ConfirmPlus.ok_button_element.addEventListener("click", ConfirmPlus.perform_ok);
            ConfirmPlus.cancel_button_element.addEventListener("click", ConfirmPlus.perform_cancel);
            ConfirmPlus.overlay_element.addEventListener("keydown", ConfirmPlus.overlay_keydown);
            ConfirmPlus.overlay_element.addEventListener("mousedown", ConfirmPlus.overlay_mousedown);
            //-----------------------------

            ConfirmPlus.IS_INITIALZED = true;
        }
    }

    private static perform_ok(): void {
        //UTL.show_which_element_has_focus();

        document.body.removeChild(ConfirmPlus.overlay_element);
        // אבל בינתיים זה עובד בלי זה. יש לזכור הערה זו למידה ויהיו בעיות setTimeout() באמצעות  resolve_function בעקרון אני חושב/חשבתי שצריך לקרוא ל
        // אבל בינתיים זה עובד בלי זה. יש לזכור הערה זו למידה ויהיו בעיות setTimeout() באמצעות  resolve_function בעקרון אני חושב/חשבתי שצריך לקרוא ל
        // אבל בינתיים זה עובד בלי זה. יש לזכור הערה זו למידה ויהיו בעיות setTimeout() באמצעות  resolve_function בעקרון אני חושב/חשבתי שצריך לקרוא ל
        ConfirmPlus.resolve_function_pointer(true);
        ConfirmPlus.resolve_function_pointer = null; // כדי שלא נקרא בפעם אחרת בטעות לפונקציה ישנה  
    }

    private static perform_cancel(): void {
        //UTL.show_which_element_has_focus();

        document.body.removeChild(ConfirmPlus.overlay_element);
        // אבל בינתיים זה עובד בלי זה. יש לזכור הערה זו למידה ויהיו בעיות setTimeout() באמצעות  resolve_function בעקרון אני חושב/חשבתי שצריך לקרוא ל
        // אבל בינתיים זה עובד בלי זה. יש לזכור הערה זו למידה ויהיו בעיות setTimeout() באמצעות  resolve_function בעקרון אני חושב/חשבתי שצריך לקרוא ל
        // אבל בינתיים זה עובד בלי זה. יש לזכור הערה זו למידה ויהיו בעיות setTimeout() באמצעות  resolve_function בעקרון אני חושב/חשבתי שצריך לקרוא ל
        ConfirmPlus.resolve_function_pointer(false);
        ConfirmPlus.resolve_function_pointer = null; // כדי שלא נקרא בפעם אחרת בטעות לפונקציה ישנה  
    }


    public static prepare(): void {
        ConfirmPlus.perform_INITIALZE_INA();

        if (true) {

            //xyz();
            PopupPlusAuxFunctions.apply_style_to_overlay_element(ConfirmPlus.overlay_element, ConfirmPlus.par_style_rec);
            PopupPlusAuxFunctions.apply_style_to_popup_element(ConfirmPlus.popup_element, ConfirmPlus.par_style_rec);
            PopupPlusAuxFunctions.apply_style_to_caption_element(ConfirmPlus.caption_element, ConfirmPlus.par_style_rec);
            PopupPlusAuxFunctions.apply_style_to_text_element(ConfirmPlus.text_element, ConfirmPlus.par_style_rec);
            PopupPlusAuxFunctions.apply_style_to_panel_element(ConfirmPlus.panel_element, ConfirmPlus.par_style_rec);
            PopupPlusAuxFunctions.apply_style_to_ok_button_element(ConfirmPlus.ok_button_element, ConfirmPlus.par_style_rec);
            PopupPlusAuxFunctions.apply_style_to_cancel_button_element(ConfirmPlus.cancel_button_element, ConfirmPlus.par_style_rec);
        }

        if (true) {
            if (ConfirmPlus.par_caption_str == null) {
                ConfirmPlus.caption_element.style.display = "none";
            }
            if (ConfirmPlus.par_caption_str != null) {
                ConfirmPlus.caption_element.style.display = "block";
            }
        }
        if (true) {
            ConfirmPlus.caption_element.innerText = ConfirmPlus.par_caption_str;
            //ConfirmPlus.text_element.innerText = ConfirmPlus.par_text_str;
            ConfirmPlus.text_element.innerHTML = ConfirmPlus.par_text_str; //innerHTML ל innerText שינינו מ
            //ConfirmPlus.text_element.style.fontSize = ConfirmPlus.par_style_rec.text_element_fontSize;
        }

    }

    public static executor_function(p_resolve: Function, p_reject: Function): void {
        //debugger;
        // כדי לא להתבלבל עם מחלקות אחרות. בהמשך יש כנראה להוריד את זה "ConfirmPlus_" הוספנו כאן את הקידומת
        // כדי לא להתבלבל עם מחלקות אחרות. בהמשך יש כנראה להוריד את זה "ConfirmPlus_" הוספנו כאן את הקידומת
        // כדי לא להתבלבל עם מחלקות אחרות. בהמשך יש כנראה להוריד את זה "ConfirmPlus_" הוספנו כאן את הקידומת
        ConfirmPlus.resolve_function_pointer = p_resolve;
        ConfirmPlus.prepare();
        document.body.appendChild(ConfirmPlus.overlay_element);
        UTL.center_popup_element_inside_overlay_element(ConfirmPlus.popup_element, ConfirmPlus.overlay_element);
        // onfocus,onblur אמר שכנראה האינדיקציה לאיזה כפתור יש את הפוקוס אינה אמינה ולכן אנחנו מיישמים אתgemini לזכירך
        // onfocus,onblur אמר שכנראה האינדיקציה לאיזה כפתור יש את הפוקוס אינה אמינה ולכן אנחנו מיישמים אתgemini לזכירך
        // onfocus,onblur אמר שכנראה האינדיקציה לאיזה כפתור יש את הפוקוס אינה אמינה ולכן אנחנו מיישמים אתgemini לזכירך
        //ConfirmPlus.cancel_button_element.focus();
        ConfirmPlus.ok_button_element.focus();
    }


    public static ShowAsync(p_text_str: string, p_caption_str: string = null, p_style_rec: PopupPlusStyleRecord = null): Promise<boolean> {
        // או פשוט לספק פרמטר אחד של הטקסט caption בפרמטר של ה null יש להציב caption אם לא רוצים לראות את ה
        // או פשוט לספק פרמטר אחד של הטקסט caption בפרמטר של ה null יש להציב caption אם לא רוצים לראות את ה

        //  overlay_BackgroundColor = rgba(0, 0, 0, 0.5)" :אפשר להציב overlay להזכירך: אם לא רוצים לראות את ה
        //  overlay_BackgroundColor = rgba(0, 0, 0, 0.5)" :אפשר להציב overlay להזכירך: אם לא רוצים לראות את ה
        //  overlay_BackgroundColor = rgba(0, 0, 0, 0.5)" :אפשר להציב overlay להזכירך: אם לא רוצים לראות את ה

        if (p_style_rec != null && (p_style_rec instanceof PopupPlusStyleRecord) == false) {
            alert("ConfirmPlus.p_style_rec is not PopupPlusStyleRecord");
            return;
        }
        // כאן יש להוסיף בדיקות בהמשך
        // כאן יש להוסיף בדיקות בהמשך
        // כאן יש להוסיף בדיקות בהמשך
        ConfirmPlus.par_text_str = p_text_str;
        ConfirmPlus.par_caption_str = p_caption_str;
        ConfirmPlus.par_style_rec = p_style_rec;
        if (ConfirmPlus.par_style_rec == null) {
            ConfirmPlus.par_style_rec = PopupPlusAuxFunctions.create_rec_style_v1("ltr", "20px", false);
        }
        return new Promise(ConfirmPlus.executor_function);
    }

}
